export default __webpack_public_path__ + "static/media/caza2.88872db7.svg";